
import FetchData from '@ezviz/FetchData';
import moment from "moment";
import { message } from "antd";
import Cookies from "js-cookie";
import util from './../../utils/utils';
import { publishProduct } from './product';
import { getMinProgramId } from './appDevelopPannel';
import intl, { init } from 'react-intl-universal';

export const GET_PANNEL_LIST = "GET_PANNEL_LIST";
export const GET_SELECT_MODAL = "GET_SELECT_MODAL";
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const SET_MINIPROGRAM_STATUS = "SET_MINIPROGRAM_STATUS";
export const GET_MINIPROGRAM_STATUS = "GET_MINIPROGRAM_STATUS";
export const FETCH_EIBPANELLIST_LOADING = "FETCH_EIBPANELLIST_LOADING";
export const FETCH_EIBPANELLIST_SUCCESS = "FETCH_EIBPANELLIST_SUCCESS";
export const FETCH_EIBPANELLIST_FAILED = "FETCH_EIBPANELLIST_FAILED";
export const FETCH_SELECT_EIBPANELLIST_LOADING = "FETCH_SELECT_EIBPANELLIST_LOADING";
export const FETCH_SELECT_EIBPANELLIST_SUCCESS = "FETCH_SELECT_EIBPANELLIST_SUCCESS";
export const FETCH_SELECT_EIBPANELLIST_FAILED = "FETCH_SELECT_EIBPANELLIST_FAILED";

moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

// 存储小程序面板列表
export function saveProgramPannelList(data) {
  return (dispatch, getState) => {
    const { pannelList } = getState().appDevelopPannel;
    const newData = Object.assign([], pannelList, data);
    dispatch({
      type: GET_PANNEL_LIST,
      pannelList: newData
    });
  };
}

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

export function setMiniProgramStatus(data) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_MINIPROGRAM_STATUS,
      isMiniProgram: data
    });
  };
}

export function getMiniProgramStatus(data) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_MINIPROGRAM_STATUS,
      miniProgramStatus: data
    })
  }
}


export function getList(params) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { mainCategoryId, categoryId, mainCategory, category, productId } = productDetail;
    const defaultParam = {
      firstCategory: mainCategory,
      secondCategory: category,
      productId: productId,
      pageStart: 0,
      pageSize: 100
    };
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/page`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200 && data.data) {
          const res = data.data;
          let miniProgramList = [];
          let programList = [];
          if (res.miniProgram && res.miniProgram.length > 0) {
            const list = res.miniProgram;
            list.map((item) => {
              let temp = {
                panelId: item.id,
                panelName: item.cnName,
                // panelEnName: item.enName,
                picture: item.logo
              };
              miniProgramList.push(temp);
            })
          }
          if (res.pannel && res.pannel.length > 0) {
            programList = data.data.pannel
          }
          const newData = [...miniProgramList, ...programList];
          dispatch(saveProgramPannelList(newData));
        }
      })
      .catch(e => {
        message.error(intl.get(`commmon.operate.retry`));
      });
  };
}

export function getSelectModal(params, callback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { firmwareUpgradeCode, productId } = productDetail;
    const defaultParam = {
      productId,
      firmwareUpgradeCode: firmwareUpgradeCode
    };
    const req = Object.assign({}, defaultParam, params);
    dispatch(updateLoadingStatus(true));
    const fetchData = new FetchData(
      `/iot/config/api/iot/operation/getPIdDetailInfo?pId=${req.productId}&firmwareUpgradeCode=${req.firmwareUpgradeCode
      }`,
      {
        method: "POST",
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      }
    );
    fetchData
      .then(data => {
        dispatch(updateLoadingStatus(false));
        if (data.code == 200) {
          dispatch({
            type: GET_SELECT_MODAL,
            pIdDetail: data.data || {}
          });
          dispatch(getMinProgramId(data.data.rnName));
          dispatch(setMiniProgramStatus(data.data.miniProgram));
          dispatch(getMiniProgramStatus(data.data.miniProgramStatus));
          if (callback) {
            callback();
          }
        }
      })
      .catch(e => {
        dispatch(updateLoadingStatus(false));
        message.error(intl.get(`commmon.operate.retry`));
      });
  };
}

export function selectModal(param, callback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { firmwareUpgradeCode, productId } = productDetail;
    const defaultParam = {
      rnPanel: '',
      pId: productId,
      firmwareUpgradeCode: firmwareUpgradeCode
    };
    const req = Object.assign({}, defaultParam, param);
    ;
    const fetchData = new FetchData(`/iot/config/api/iot/support/product/panel/config`, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          callback && callback();
          message.success(intl.get('commmon.operate.success'));
          // 2021-01-05 更换面板后，调用一次发布接口
          dispatch(publishProduct({ productId }))
        } else if (data && data.code == 60016) {
          message.error(data.msg);
        }
      })
      .catch(e => {
        // message.error(intl.get(`commmon.operate.retry`));
      });
  };
}


// EIB 相关
// 获取EIB面板信息
export function getEIBPanelList(params = {}) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId, firmwareUpgradeCode, mainCategory, category } = productDetail;
    dispatch({
      type: FETCH_EIBPANELLIST_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/manager/panel/getAllPanels?pid=${productId}&pVersion=${firmwareUpgradeCode}&firstCat=${mainCategory}&secondCat=${category}`, {
      method: "GET",
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {

        if (res.meta && res.meta.code == 200 && res.data) {
          dispatch({
            type: FETCH_EIBPANELLIST_SUCCESS,
            eibPanelList: res.data,
          });
        } else {
          dispatch({
            type: FETCH_EIBPANELLIST_FAILED,
          });
        }
      })
      .catch(e => {
        // message.error(intl.get(`commmon.operate.retry`));
        dispatch({
          type: FETCH_EIBPANELLIST_FAILED,
        });
      });
  };
}


/**
 * 面板入口配置
 */
export const EIB_ENTRY_CONFIG = JSON.stringify({
  isMiniProgram: true,
  aVer: "35",
  iVer: "1.3.1",
  settings: { entry: "EIBSettingMain" },
  card: { eib: true },
  detail: { entry: "EIBDetailMain" }
})

//小程序包名
export const EIB_RN_PACKAGE = "MiniRepertory";

// 选择EIB面板
export function selectEIBPanel(params, callback) {
  return (dispatch, getState) => {
    const { productId } = getState().product.productDetail;
    const body = {
      pid: productId,
      config: EIB_ENTRY_CONFIG,
      rnName: EIB_RN_PACKAGE,
      // eibConfig: params.eibConfig,
      firstCategory: params.firstCategory,
      panelId: params.panelId,
      panelName: params.panelName,
      picture: params.picture,
      // pid: params.pid,
      secondCategory: params.secondCategory,
      status: params.status,
      version: params.version,
      pVersion: params.pidVersion,
      baseVersion: params.baseVersion,
    }
    // 自动加上 cardConfig
    const tempEibConfig = util.parseJSON(params.eibConfig);
    Object.keys(tempEibConfig).forEach(key => {
      if (!tempEibConfig[key].useInnerCard) {
        tempEibConfig[key].cardConfig = {}
      }
    })
    body.eibConfig = JSON.stringify(tempEibConfig)
    dispatch({
      type: FETCH_SELECT_EIBPANELLIST_LOADING,
    });
    const isOnline = window.location.host === 'iot.eziot.com';
    const envs = isOnline ? 'iotcn_online,iotus_online' : 'test15';
    const fetchData = new FetchData(`/iot/config/api/iot/manager/panel/select?envs=${envs}&fromIot=true`, {
      method: "PUT",
      body,
      headers: {
        appId: 'default',
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.meta && res.meta.code == 200) {
          dispatch({
            type: FETCH_SELECT_EIBPANELLIST_SUCCESS,
          });
          dispatch(getEIBPanelList());
          callback && callback();
        } else {
          dispatch({
            type: FETCH_SELECT_EIBPANELLIST_FAILED,
          });
        }
      })
      .catch(e => {
        // message.error(intl.get(`commmon.operate.retry`));
        dispatch({
          type: FETCH_SELECT_EIBPANELLIST_FAILED,
        });
      });
  };
}
